/**
 * Marks PDP gallery photos as loaded so their low-res placeholder (snippets/product-media.liquid,
 * `.product-media[data-placeholder]`) stops showing.
 *
 * The placeholder is purely cosmetic: if this script never runs, the only effect is that the soft 300px
 * copy stays behind the photo (invisible for opaque photos). Nothing here stops or changes any event.
 */
const BOX = '.product-media[data-placeholder]';

/** @param {Element | null} img */
const markLoaded = (img) => {
  const box = img?.closest?.(BOX);
  if (box && !box.hasAttribute('data-loaded')) box.setAttribute('data-loaded', '');
};

/** @param {ParentNode} root */
const sweep = (root) => {
  for (const img of root.querySelectorAll(`${BOX} img`)) {
    if (img instanceof HTMLImageElement && img.complete && img.naturalWidth > 0) markLoaded(img);
  }
};

if (!window.__seneMediaPlaceholder) {
  window.__seneMediaPlaceholder = true;

  try {
    // `load` does not bubble, but it can be captured on the document.
    document.addEventListener(
      'load',
      (event) => {
        if (event.target instanceof HTMLImageElement) markLoaded(event.target);
      },
      true
    );

    sweep(document);

    // The server replaces the whole <media-gallery> on a colour change. Cached photos are `complete` the
    // moment they are inserted, so mark them before the browser paints (observer callbacks run first).
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof Element && (node.matches(BOX) || node.querySelector(BOX))) sweep(node);
        }
      }
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  } catch (e) {
    /* never interfere with the page */
  }
}
